import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import {LOT_NO_REGEX} from "@/plugins/vee-validate";

export default class BidModel extends BaseModel {
    uuid = null;
    lot_no = null;
    lot_uuid = null;
    bidder_uuid = null;
    amount = null;
    auction_uuid = null;
    paddle_number = null;

    static TRANSLATABLE_FIELDS = [];

    rules = {
        lot_no: {
            required: true,
            regex: LOT_NO_REGEX
        },
        amount: 'required',
        paddle_number: 'required',
    };

    attributeLabels = {
        lot_no: i18n.t('Lot'),
        amount: i18n.t('Amount'),
        bidder_uuid: i18n.t('Bidder'),
        auction_uuid: i18n.t('Sale'),
        paddle_number: i18n.t('Paddle Number'),
        lot_uuid: i18n.t('Lot')
    };

    constructor(data = {}) {
        super();
        Object.assign(this, {...data});
        this.initTranslatableFields(this);
    }
}

defineTranslatableProperties(BidModel);
